export var CartonType;
(function (CartonType) {
    CartonType[CartonType["BOX"] = 1] = "BOX";
    CartonType[CartonType["PALLET"] = 2] = "PALLET";
    CartonType[CartonType["ENVELOPE"] = 3] = "ENVELOPE";
})(CartonType || (CartonType = {}));
//# sourceMappingURL=carton-type.js.map